import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";

import { AccessDeniedPage } from "./pages/access-denied/access-denied.component";
import { AccessDeniedSelectProductPage } from "./pages/access-denied-select-product/access-denied-select-product.component";
import { HomePage } from "./pages/home/home.component";
import { NotFoundPage } from "./pages/not-found/not-found.component";
import { ProductDocsPage } from "./pages/product-docs/product-docs.component";
import { TechnicalErrorPage } from "./pages/technical-error/technical-error.component";

const routes: Routes = [
  {
    path: "",
    pathMatch: "full",
    component: HomePage,
  },
  {
    path: "access-denied",
    component: AccessDeniedPage,
  },
  {
    path: "access-denied-select-product",
    component: AccessDeniedSelectProductPage,
  },
  {
    path: "error",
    component: TechnicalErrorPage,
  },
  {
    path: ":productId",
    component: ProductDocsPage,
  },
  {
    path: "**",
    component: NotFoundPage,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
